import { render, staticRenderFns } from "./provinsi.vue?vue&type=template&id=53c60bfa"
import script from "./provinsi.vue?vue&type=script&lang=js"
export * from "./provinsi.vue?vue&type=script&lang=js"
import style0 from "./provinsi.vue?vue&type=style&index=0&id=53c60bfa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports